export default __webpack_public_path__ + "static/media/ampersand.8721b762.svg";